import { useMemo, useState } from 'react'
import * as ZonaEntregaHttp from '../../../../services/api/https/registration/zona-entrega.http'

import { errorHandler } from '../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  LOADING: 'Carregando',
}

const buildInitialState = () => ({
  zonasEntrega: [],
  modal: {
    show: false,
    data: null,
  },
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  globalFilter: '',
})

export default function useZonaEntrega() {
  const [state, setState] = useState(buildInitialState)

  const localDispatch = useMemo(() => {
    return {
      // Actions
      resetState() {
        setState(buildInitialState())
      },

      // Events
      onInit(selectedTp) {
        if (selectedTp === 0)
          return setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: 'Selecione um Operador Logístico',
          }))
        setState(prevState => ({
          ...prevState,
          selectedTp: selectedTp,
          loadingMessage: LOAD_MESSAGE.LOADING,
        }))
      },

      loadZonasEntrega(selectedTp) {
        ZonaEntregaHttp.getZonasEntrega(selectedTp)
          .then(zonasEntrega => {
            setState(prevState => ({
              ...prevState,
              zonasEntrega,
              loadingMessage: LOAD_MESSAGE.NONE,
            }))
          })
          .catch(error => {
            errorHandler(error)
            setState(prevState => ({
              ...prevState,
              loadingMessage: LOAD_MESSAGE.NONE,
              errorMessage: 'Erro ao carregar as zonas de entrega',
            }))
          })
      },

      resetErrorMessage() {
        setState(prevState => ({
          ...prevState,
          errorMessage: null,
          loadingMessage: LOAD_MESSAGE.NONE,
        }))
      },

      onBtnNovo(selectedTp) {
        if (selectedTp === 0)
          return setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.NONE,
            errorMessage: 'Selecione um Operador Logístico',
          }))
        setState(prevState => ({ ...prevState, modal: { show: true, data: null } }))
      },

      onModalClose() {
        setState(prevState => ({ ...prevState, modal: { show: false, data: null } }))
      },

      onModalSave(zonaEntrega) {
        setState(prevState => {
          const index = prevState.zonasEntrega.findIndex(zona => zona.id === zonaEntrega.id)
          const zonasEntrega =
            index !== -1
              ? prevState.zonasEntrega.map((zona, i) => (i === index ? zonaEntrega : zona))
              : [zonaEntrega, ...prevState.zonasEntrega]

          return {
            ...prevState,
            zonasEntrega,
            modal: { show: false, data: null },
            loadingMessage: LOAD_MESSAGE.NONE,
          }
        })
      },

      onDataTableItemClicked(zonaEntrega) {
        setState(prevState => ({ ...prevState, modal: { show: true, data: { ...zonaEntrega } } }))
      },

      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },
    }
  }, [])

  return { state, localDispatch }
}
